import { getValue } from "@utils/lodash";
import "./index.scss";
import DragAndDropFileComponent from "@_common/file-drag-drop";
export default function ImportData(props: any) {
	const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
	return (
		<div className="popup-wrapper__details">
			<div className="popup-wrapper__download">
				<button
					className="popup-wrapper__download-btn"
					onClick={props.handleDownload}
				>
					Download Template
				</button>
			</div>
			<div className="popup-wrapper__import">
				<h6 className="popup-wrapper__import-title">Import Data</h6>
				<p className="popup-wrapper__import-text">
					<span className="d-block">Instructions </span>
					Use the template provided and import data using excel. Ensure no duplicates, incorrect format is added. Please wait after you have uploaded.
				</p>
			</div>
			<div className="uploaded-details-wrapper__header uploaded-details-wrapper__header-checkpoint ">
				<div className="attach-files-wrapper">
				
						<label className="input-file-label position-relative w-100 text-center cursor-pointer mb-4">
							{/* <input
									type={"file"}
									onChange={handleUploadDocumnets}
									multiple
									className="d-none"
								/> */}
							<div
							// className="d-none"
							>
								<DragAndDropFileComponent
									uploadFile={props.handleChangeUpload}
									name="file"
									types={fileTypes}
									multiple
									// className="d-none"
									classes="bulk-upload_drag-n-drop-wrapper position-absolute"
									fileName={getValue(props,`importedFile.name`,'')}
									setImportTedFile={props.setImportTedFile}
								/>
							</div>
						</label>
					
				</div>
			</div>
			<div className="popup-wrapper__cta-btns">
				<button
					className="popup-wrapper__cta-button popup-wrapper__cta-button--secondary mx-3"
					onClick={() => {
						props.closePopup();
					}}
				>
					Cancel
				</button>

				<button
					className="popup-wrapper__cta-button popup-wrapper__cta-button--primary"
					onClick={() => {
						props.handleUpload();
					}}
					disabled={getValue(props, `submitLoading`, false)}
				>
					{getValue(props, `submitLoading`, false)
						? "Please wait..."
						: "Import"}
				</button>
			</div>
		</div>
	);
}
